var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBri(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 33,
    viewBox: "0 0 46 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 32.8571,
    rx: 2.70857,
    fill: "#00529C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6367 14.2544H15.8291C16.717 14.2544 17.3788 14.6472 17.3788 15.4742C17.3788 16.0805 17.072 16.4181 16.539 16.597V16.6107C17.1743 16.742 17.5021 17.0865 17.5021 17.6719C17.5021 18.8229 16.4979 19.0638 15.6443 19.0638H13.6367V14.2544ZM14.9066 16.1562H15.2621C15.6787 16.1562 16.1092 16.0528 16.1092 15.646C16.1092 15.2055 15.6993 15.1638 15.2754 15.1638H14.9066V16.1562ZM14.9066 18.1545H15.2829C15.7469 18.1545 16.2316 18.0855 16.2316 17.5962C16.2316 17.0729 15.7334 17.0243 15.2962 17.0243H14.9066V18.1545Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1691 14.2544H20.7263L22.5634 19.0638H21.1701L20.8152 18.0374H19.0259L18.6501 19.0638H17.3594L19.1691 14.2544ZM19.948 15.2471H19.9337L19.3194 17.1284H20.5145L19.948 15.2471Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7405 14.2544H24.359L25.9708 17.5207H25.9841L25.9639 14.2544H27.1253V19.0638H25.5476L23.8807 15.7772H23.8676L23.9083 19.0638H22.7405V14.2544Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5564 14.2544H28.8265V16.2187H28.8402L30.2739 14.2544H31.8043L30.0419 16.4936L31.9408 19.0638H30.3217L28.8402 16.8798H28.8265V19.0638H27.5564V14.2544Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5156 14.2544H35.708C36.5957 14.2544 37.2584 14.6472 37.2584 15.4742C37.2584 16.0805 36.9515 16.4181 36.4186 16.597V16.6107C37.0536 16.742 37.3814 17.0865 37.3814 17.6719C37.3814 18.8229 36.3774 19.0638 35.5241 19.0638H33.5156V14.2544ZM34.7861 16.1562H35.141C35.5578 16.1562 35.9876 16.0528 35.9876 15.646C35.9876 15.2055 35.5783 15.1638 35.1551 15.1638H34.7861V16.1562ZM34.7861 18.1545H35.162C35.6259 18.1545 36.1111 18.0855 36.1111 17.5962C36.1111 17.0729 35.6126 17.0243 35.1755 17.0243H34.7861V18.1545Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6628 14.2544H39.9303C40.777 14.2544 41.4671 14.6401 41.4671 15.4675C41.4671 16.1082 41.1665 16.5354 40.5521 16.6799V16.6935C40.9609 16.804 40.9888 17.169 41.2278 17.7547L41.6924 19.0638H40.3677L40.0943 18.1962C39.8347 17.3693 39.6707 17.162 39.1994 17.162H38.9329V19.0638H37.6628V14.2544ZM38.9329 16.2527H39.2678C39.6775 16.2527 40.1968 16.2386 40.1968 15.6944C40.1968 15.2468 39.7523 15.1638 39.2678 15.1638H38.9329V16.2527Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2272_7826",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 11,
    width: 42,
    height: 11
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62866 21.4924H43.3125V11.8286H2.62866V21.4924Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2272_7826)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0425 19.0638H43.3126V14.2544H42.0425V19.0638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7379 11.8286H4.08979C3.28283 11.8286 2.62866 12.505 2.62866 13.3395V13.3554V19.9819C2.62866 20.8083 3.27078 21.48 4.06734 21.4924H10.7344C11.5416 21.4924 12.196 20.816 12.196 19.9819L12.1991 13.3395C12.1991 12.505 11.5451 11.8286 10.7379 11.8286ZM4.88003 20.718L4.5173 20.722C4.07827 20.722 3.7224 20.3581 3.7224 19.9091L3.72032 19.8451V13.7106L3.7226 13.3803C3.73903 12.9457 4.06622 12.5959 4.49485 12.5959H5.23217C5.90027 12.5959 6.44219 13.1821 6.44219 13.8738C6.44219 14.2156 6.30936 14.526 6.09421 14.7517L4.21297 16.6776L5.97614 18.489C6.20355 18.7254 6.34096 19.0362 6.34096 19.3766C6.34096 20.1175 5.68678 20.718 4.88003 20.718ZM10.3004 20.7119L7.01316 20.7104C7.01316 20.7104 7.39335 19.8816 7.39335 19.3686C7.39335 18.7432 7.1859 18.1843 6.86141 17.8145L5.73703 16.6581L6.88469 15.4618C7.22623 15.1378 7.45322 14.5627 7.45322 13.9078C7.45322 13.3891 7.31104 12.9296 7.08217 12.5959H7.87874C8.54704 12.5959 9.08896 13.1821 9.08896 13.8738C9.08896 14.2156 8.95634 14.526 8.74119 14.7517L6.89592 16.6575L10.7284 20.6005C10.6071 20.6777 10.4538 20.7119 10.3004 20.7119ZM11.1033 19.4809L8.35666 16.6568L9.6648 15.3154C9.93129 14.9796 10.1001 14.4735 10.1001 13.9079C10.1001 13.3859 9.95582 12.9153 9.72487 12.5814L10.3104 12.599C10.7495 12.599 11.1054 12.9635 11.1054 13.4123L11.1033 19.4809Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBri);
export default __webpack_public_path__ + "static/media/bri.9ae5fe19b55fd315bf05faefb37dec1f.svg";
export { ForwardRef as ReactComponent };